import React, { useState, useEffect } from 'react';
import CountriesModalComponent from './CountriesModalComponent';
import TermsModalComponent from './TermsModalComponent';
import ErrorModalComponent from './ErrorModalComponent';

const ModalContainerComponent = (props) => {
  const [selectedModalCountry, setSelectedModalCountry] = useState('');
  const [
    selectedModalCurrentCountry,
    setSelectedModalCurrentCountry,
  ] = useState('');
  const [firstOptionChoice, setFirstOptionChoice] = useState(null);
  const [secondOptionChoice, setSecondOptionChoice] = useState(null);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const checkCountries = (country, currentCountry) => {
    if (
      country &&
      currentCountry &&
      (country.toLowerCase() === 'sweden' ||
        country.toLowerCase() === 'sverige') &&
      (currentCountry.toLowerCase() === 'sweden' ||
        currentCountry.toLowerCase() === 'sverige')
    ) {
      return true;
    } else return false;
  };

  let contentComponent = null;

  const handleBack = () => {
    setSelectedModalCountry('');
    setSelectedModalCurrentCountry('');
    setIsErrorModalOpen(false);
    setFirstOptionChoice('');
    setSecondOptionChoice('');
  };

  const handleRedirect = () => {
    window.location.href = '/';
  };

  const handleButtonChoice = (choice, option) => {
    if (option === 'first') {
      setFirstOptionChoice(choice);
    } else if (option === 'second') {
      setSecondOptionChoice(choice);
    }
  };

  const shouldShowErrorModal =
    (firstOptionChoice === 'no' && secondOptionChoice === 'no') ||
    (firstOptionChoice === 'yes' && secondOptionChoice === 'no') ||
    (firstOptionChoice === 'no' && secondOptionChoice === 'yes');

  const shouldCloseModal =
    firstOptionChoice === 'yes' && secondOptionChoice === 'yes';

  if (shouldCloseModal && props.onClose) {
    props.onClose();
    setFirstOptionChoice('');
    setSecondOptionChoice('');
    setSelectedModalCountry('');
    setSelectedModalCurrentCountry('');
  }

  if (
    !selectedModalCountry &&
    !selectedModalCurrentCountry &&
    !isErrorModalOpen
  ) {
    contentComponent = (
      <CountriesModalComponent
        modalTitle={props.modalTitle}
        modalText={props.modalText}
        modalCountry={props.modalCountry}
        modalCurrentCountry={props.modalCurrentCountry}
        onSelect={(country, currentCountry) => {
          setSelectedModalCountry(country);
          setSelectedModalCurrentCountry(currentCountry);
        }}
      />
    );
  } else if (
    checkCountries(selectedModalCountry, selectedModalCurrentCountry)
  ) {
    if (!shouldShowErrorModal && !shouldCloseModal) {
      contentComponent = (
        <TermsModalComponent
          modalTermsText={props.modalTermsText}
          onClose={props.onClose}
          onRedirect={handleRedirect}
          onButtonChoice={(choice, option) =>
            handleButtonChoice(choice, option)
          }
        />
      );
    } else if (shouldShowErrorModal && !shouldCloseModal) {
      contentComponent = (
        <ErrorModalComponent onBack={handleBack} onRedirect={handleRedirect} />
      );
    }
  } else if (
    !checkCountries(selectedModalCountry, selectedModalCurrentCountry)
  ) {
    contentComponent = (
      <ErrorModalComponent onBack={handleBack} onRedirect={handleRedirect} />
    );
  }

  return <div>{contentComponent}</div>;
};

export default ModalContainerComponent;
